import Fab from "@mui/material/Fab";
import { PropTypes } from "prop-types";

const ButtonLogOut = (props) => {
  return (
    <Fab
      sx={{ height: "100%" }}
      variant="extended"
      color="primary"
      onClick={props.handleClick}
    >
      Αποσύνδεση
    </Fab>
  );
};

export default ButtonLogOut;

ButtonLogOut.propTypes = {
  handleClick: PropTypes.func.isRequired,
};
